const notificationActionTypes = {
  NOTIFICATION_SET_NOTIFICATIONS: 'NOTIFICATION_SET_NOTIFICATIONS',
};

export default notificationActionTypes;
